var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAimLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.94 69.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M69.41,4.38h11.26s-4.5,15.66-6.72,23.3c-3.17,10.87-6.37,21.73-9.54,32.6h-11.26L69.41,4.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "101.31 13.05 90.6 54.41 79.34 54.41 91.31 13.06 101.31 13.05"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M42.6,35.1c1.63-5.57,5.82-19.62,5.82-19.62h11.22l-11.41,38.93h-11.26c1.81-6.45,3.74-12.88,5.63-19.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M35.95,13.13c-1.77,5.99-3.55,11.99-5.32,17.98-.39,1.33-1.25,4.22-1.25,4.22l2.37-.02,2.1,7.84h-.87c-1.96,0-5.9,0-5.9,0l-1.61,5.48h-9.93L25.95,13.06l10,.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070"
    },
    d: "M80.79,4.38l5.28,26.82-6.72,23.22h-.2s-5.19-26.74-5.19-26.74c2.23-7.63,6.72-23.3,6.72-23.3h.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#707070"
    },
    points: "35.95 13.13 42.6 35.1 36.97 54.41 36.87 54.41 30.64 31.11 35.95 13.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#707070"
    },
    points: "109.76 39.32 105.38 39.32 102.71 48.62 102.61 48.62 96.82 30.37 101.28 13.01 109.76 39.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "64.25 0 61.2 10.63 49.95 10.63 52.84 0 64.25 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M109.75,39.32c1.82,0,3.65,0,5.47,0l-2.42,9.22-10.09.08,2.66-9.3c1.46,0,2.92,0,4.37,0Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.68,65.59c.85.07,1.65.34,2.04,1.17.42.91.17,1.99-.67,2.54-.11.07-.66.36-.74.36h-2.23v-4.07c.52.03,1.09-.04,1.6,0h0ZM87.94,68.87h1.21s.38-.22.43-.27c.55-.51.54-1.52-.09-1.95-.37-.26-1.17-.43-1.56-.16v2.38h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M1.75,65.53h.83l1.75,4.12h-.94l-.37-.92h-1.73l-.37.92h-.92l1.75-4.12ZM2.7,67.93l-.54-1.32-.54,1.32h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M4.78,69.05l.53-.64c.37.3.75.5,1.22.5.37,0,.59-.15.59-.38h0c0-.24-.14-.36-.82-.53-.83-.2-1.35-.44-1.35-1.25h0c0-.75.59-1.24,1.43-1.24.6,0,1.1.19,1.52.52l-.47.68c-.37-.25-.71-.4-1.06-.4s-.53.15-.53.36h0c0,.28.18.36.88.55.83.22,1.3.51,1.3,1.23h0c0,.82-.62,1.28-1.5,1.28-.62,0-1.24-.21-1.73-.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M8.62,69.05l.53-.64c.37.3.75.5,1.22.5.37,0,.59-.15.59-.38h0c0-.24-.14-.36-.82-.53-.83-.2-1.35-.44-1.35-1.25h0c0-.75.59-1.24,1.43-1.24.6,0,1.1.19,1.52.52l-.47.68c-.37-.25-.71-.4-1.06-.4s-.53.15-.53.36h0c0,.28.18.36.88.55.83.22,1.3.51,1.3,1.23h0c0,.82-.62,1.28-1.5,1.28-.62,0-1.24-.21-1.73-.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M12.61,67.61h0c0-1.17.92-2.12,2.18-2.12s2.17.94,2.17,2.1h0c0,1.17-.92,2.12-2.18,2.12s-2.17-.94-2.17-2.1ZM16.01,67.61h0c0-.71-.51-1.3-1.24-1.3s-1.23.57-1.23,1.27h0c0,.71.51,1.3,1.24,1.3s1.23-.57,1.23-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M17.73,67.61h0c0-1.17.88-2.12,2.13-2.12.76,0,1.24.26,1.61.63l-.57.66c-.32-.29-.63-.46-1.05-.46-.69,0-1.19.57-1.19,1.27h0c0,.71.49,1.3,1.19,1.3.47,0,.75-.18,1.07-.48l.57.58c-.42.45-.88.73-1.67.73-1.2,0-2.1-.93-2.1-2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M22.41,65.56h.9v4.09h-.9v-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M25.89,65.53h.83l1.75,4.12h-.94l-.37-.92h-1.73l-.37.92h-.92l1.75-4.12ZM26.84,67.93l-.54-1.32-.54,1.32h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M29.69,66.38h-1.24v-.83h3.39v.83h-1.24v3.26h-.9v-3.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M32.72,65.56h.9v4.09h-.9v-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M34.61,67.61h0c0-1.17.92-2.12,2.18-2.12s2.17.94,2.17,2.1h0c0,1.17-.92,2.12-2.18,2.12s-2.17-.94-2.17-2.1h0ZM38.02,67.61h0c0-.71-.51-1.3-1.24-1.3s-1.23.57-1.23,1.27h0c0,.71.51,1.3,1.24,1.3s1.23-.57,1.23-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M39.91,65.56h.83l1.92,2.52v-2.52h.89v4.09h-.76l-1.98-2.6v2.6h-.89v-4.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M46.41,67.61h0c0-1.17.92-2.12,2.18-2.12s2.17.94,2.17,2.1h0c0,1.17-.92,2.12-2.18,2.12s-2.17-.94-2.17-2.1ZM49.81,67.61h0c0-.71-.51-1.3-1.24-1.3s-1.23.57-1.23,1.27h0c0,.71.51,1.3,1.24,1.3s1.23-.57,1.23-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M51.71,65.56h3.11v.82h-2.21v.87h1.95v.82h-1.95v1.58h-.9v-4.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M57.65,65.56h.9v4.09h-.9v-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M59.82,65.56h.83l1.92,2.52v-2.52h.89v4.09h-.76l-1.98-2.6v2.6h-.89v-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M64.75,65.56h1.59c1.28,0,2.17.88,2.17,2.03h0c0,1.16-.89,2.05-2.17,2.05h-1.59v-4.09h0ZM65.65,66.37v2.46h.69c.73,0,1.23-.5,1.23-1.22h0c0-.74-.5-1.24-1.23-1.24h-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M69.56,65.56h3.08v.8h-2.19v.83h1.93v.8h-1.93v.86h2.22v.8h-3.11v-4.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M73.79,65.56h1.67c.97,0,1.57.57,1.57,1.41h0c0,.96-.74,1.45-1.65,1.45h-.68v1.23h-.9v-4.09h0ZM75.4,67.62c.45,0,.71-.27.71-.62h0c0-.41-.28-.63-.73-.63h-.69v1.25h.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M77.98,65.56h3.08v.8h-2.19v.83h1.93v.8h-1.93v.86h2.22v.8h-3.11v-4.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M82.21,65.56h.83l1.92,2.52v-2.52h.89v4.09h-.76l-1.98-2.6v2.6h-.89v-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M87.11,65.56h1.59c1.28,0,2.17.88,2.17,2.03h0c0,1.16-.89,2.05-2.17,2.05h-1.59v-4.09h0ZM88.01,66.37v2.46h.69c.73,0,1.23-.5,1.23-1.22h0c0-.74-.5-1.24-1.23-1.24h-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M91.9,65.56h3.08v.8h-2.19v.83h1.93v.8h-1.93v.86h2.22v.8h-3.11v-4.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M96.09,65.56h.83l1.92,2.52v-2.52h.89v4.09h-.76l-1.98-2.6v2.6h-.89v-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M101.81,66.38h-1.24v-.83h3.39v.83h-1.24v3.26h-.9v-3.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M107.01,65.56h.97l1.07,1.73,1.07-1.73h.97v4.09h-.89v-2.26l-.81,1.86h-.6l-.9-1.84v2.24h-.88v-4.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M112.51,67.89v-2.33h.9v2.31c0,.67.33,1.01.88,1.01s.88-.33.88-.98v-2.34h.9v2.31c0,1.24-.69,1.84-1.79,1.84s-1.77-.61-1.77-1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M117.06,69.05l.53-.64c.37.3.75.5,1.22.5.37,0,.59-.15.59-.38h0c0-.24-.14-.36-.82-.53-.83-.2-1.35-.44-1.35-1.25h0c0-.75.59-1.24,1.43-1.24.6,0,1.1.19,1.52.52l-.47.68c-.37-.25-.71-.4-1.06-.4s-.53.15-.53.36h0c0,.28.18.36.88.55.83.22,1.3.51,1.3,1.23h0c0,.82-.62,1.28-1.5,1.28-.62,0-1.24-.21-1.73-.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M121.27,65.56h.9v4.09h-.9v-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M123.17,67.61h0c0-1.17.88-2.12,2.13-2.12.76,0,1.24.26,1.61.63l-.57.66c-.32-.29-.63-.46-1.05-.46-.69,0-1.19.57-1.19,1.27h0c0,.71.49,1.3,1.19,1.3.47,0,.75-.18,1.07-.48l.57.58c-.42.45-.88.73-1.67.73-1.2,0-2.1-.93-2.1-2.1h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAimLight);
export default __webpack_public_path__ + "static/media/AIM-Light.6daacb20c2a9686936033dee1f2cba82.svg";
export { ForwardRef as ReactComponent };